"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityInfo_1 = require("./EntityInfo");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Wrap a node and become an entity element
 * @param editor The editor to insert entity into.
 * @param type Type of the entity
 * @param contentNode Root element of the entity
 * @param isBlock Whether the entity will be shown as a block
 * @param isReadonly Whether the entity will be a readonly entity
 */
function createEntityWrapper(editor, type, contentNode, isBlock, isReadonly) {
    var wrapper = roosterjs_editor_dom_1.wrap(contentNode, isBlock ? 'DIV' : 'SPAN');
    wrapper.className = EntityInfo_1.serializeEntityInfo(editor, type, isReadonly);
    // For inline & readonly entity, we need to set display to "inline-block" otherwise
    // there will be some weird behavior when move cursor around the entity node.
    // And we should only do this for readonly entity since "inline-block" has some side effect
    // in IE that there will be a resize border around the inline-block element. We made some
    // workaround for readonly entity for this issue but for editable entity, keep it as "inline"
    // will just work fine.
    if (!isBlock && isReadonly) {
        wrapper.style.display = 'inline-block';
    }
    return wrapper;
}
exports.default = createEntityWrapper;
//# sourceMappingURL=createEntityWrapper.js.map